<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :name="name"
  >
    <ul class="tags-select">
      <li
        v-for="tag in tags"
        :key="tag.value"
        class="tag"
      >
        <label
          :for="tag.value"
          class="tag__label"
        >
          <input
            :id="tag.value"
            :value="tag.value"
            :checked="isSelected(tag.value)"
            class="tag__input visuallyhidden"
            type="checkbox"
            @change="handleInputValue"
          >
          <div class="tag__text">{{ tag.label }}</div>
        </label>
      </li>
    </ul>
  </form-section>
</template>

<script>
import InputCommon from './InputCommon'

export default {
  name: 'TagSelect',
  mixins: [InputCommon],
  props: {
    tags: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: []
    }
  },
  watch: {
    value () {
      this.setInputValue()
    }
  },
  methods: {
    isSelected (tag) {
      return this.selected.indexOf(tag) !== -1
    },
    addTag () {
      const tags = this.value.slice(0) || []
      tags.push(event.target.value)
      this.selected = tags
    },
    removeTag (tag) {
      const tags = this.selected.slice(0) || []
      for(var i = tags.length; i--;) {
        if (tags[i] === tag) tags.splice(i, 1)
      }
      this.selected = tags
    },
    setInputValue () {
      this.selected = this.value
    },
    handleInputValue (event) {
      const value = event.target.value

      if (event.target.checked) {
        this.addTag(value)
      } else {
        this.removeTag(value)
      }

      this.$emit('input', this.selected)
    }
  },
  mounted () {
    this.$nextTick(() => this.setInputValue())
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.tags-select
  +clearfix

.tag
  float: left
  margin: 0 5px 5px 0

.tag__text
  +font-size(15, 15)
  display: inline-block
  position: relative
  text-transform: uppercase
  background: $color-grey-1
  color: $color-black
  cursor: pointer
  transition: background-color 0.15s
  border-radius: 3px
  padding: 15px 20px
  border: 1px solid transparent

.tag__input:focus ~.tag__text
  border-color: rgba($color-black, .5)

.tag__input:checked ~ .tag__text
  background: var(--mainColor)
  color: $color-white
</style>



// WEBPACK FOOTER //
// src/components/forms/TagSelect.vue